<template>
    <div class="view-forms">
        <b-row>
            <b-col
                cols="12"
                lg="6"
                offset-lg="3"
            >
                <h1 class="text-center">List of documents</h1>

                <div v-if="!fromEmail" class="my-3">
                    <strong>{{ fullName }}</strong>, you are about to digitally sign the documents of your disclosure.
                </div>

                <div v-if="fromEmail" class="mb-4">
                    To download a certain document, click on the <strong>Download</strong> button on the right side.
                </div>

                <div v-else class="mb-4">
                    Please be sure you've carefully reviewed each document in this disclosure. If you make any changes
                    after
                    signing, all parties will need to sign the revised documents.
                </div>

                <div>
                    <div class="mb-3">
                        <form-card
                            v-for="formAppResource in formsAppResources"
                            :key="formAppResource.jotformId"
                            :form="formAppResource"
                            :fromEmail="fromEmail"
                            class="mb-2"
                            @display="downloadDocuments(formAppResource)"
                        />
                    </div>

                </div>

            </b-col>
        </b-row>
        <b-row v-if="!fromEmail">
            <b-col
                cols="12"
                lg="6"
                offset-lg="3"
            >
                <b-row>
                    <b-col cols="6">
                        <b-button
                            block
                            size="lg"
                            variant="primary"
                            @click="$bvModal.show('message-primary-seller-modal')"
                        >
                            Request Changes
                        </b-button>
                    </b-col>
                    <b-col
                        cols="6"
                    >
                        <b-button
                            block
                            size="lg"
                            variant="primary"
                            @click="next"
                        >
                            Continue
                        </b-button>
                    </b-col>
                </b-row>
            </b-col>
        </b-row>

        <message-primary-seller
            v-if="!fromEmail"
            id="message-primary-seller-modal"
            :order="order"
            :order-uuid="disclosure.orderUuid"
        />

    </div>
</template>

<script>
import SellerAppResource from "@sellers-shield-home-protection/ss-core-js/src/AppResources/SellerAppResource";
import DisclosureAppResource from "@sellers-shield-home-protection/ss-core-js/src/AppResources/DisclosureAppResource";
import OrderAppResource from "@sellers-shield-home-protection/ss-core-js/src/AppResources/OrderAppResource";
import JotformService from "@services/jotform.service";
import FormCard from "../FormCard/FormCard";
import MessagePrimarySeller from "../MessagePrimarySeller/MessagePrimarySeller";
import {orderForms} from '@helpers/order';
export default {
    name: "view-forms",
    components: {
        MessagePrimarySeller,
        FormCard,
    },
    props: {
        order: {
            type: OrderAppResource,
            required: true
        },
        seller: {
            type: SellerAppResource,
            required: true
        },
        disclosure: {
            type: DisclosureAppResource,
            required: true
        },
        fromEmail: {
            type: Boolean,
            required: false,
            default: false
        }
    },
    data: () => ({
        legalName: '',
    }),
    computed: {
        fullName() {
            return this.legalName ?
                this.legalName : this.seller.firstName + ' ' + this.seller.lastName;
        },
        formsAppResources() {
            return orderForms(this.order);
        },
        jotFormDisclosureSessions() {
            return this.disclosure?.jotFormDisclosureSessions;
        },
    },
    methods: {
        getPdfUrl(form) {
            let url = false;
            if (this.jotFormDisclosureSessions) {
                this.jotFormDisclosureSessions.forEach(file => {
                    if (file.formUuid === form.uuid) {
                        file.files.forEach(currentFile => {
                            url = window.env.MILESTONES_API_HOST + '/public/file/' + currentFile.uuid + (!this.fromEmail ? '?view=1' : '');
                        });
                    }
                });
            }
            return url;
        },
        async downloadDocuments(form) {
            let url = this.getPdfUrl(form);
            if (url) {
                const isDownloadDeactivated = await JotformService.checkMaintenance();
                if (isDownloadDeactivated) {
                    return this.$bvModal.show('maintenance-mode-modal');
                }
                return this.fromEmail ? window.open(url) : window.open(url, '_blank').focus();
            }
        },
        next() {
            this.$emit('submit');
        },
    }
}
</script>
